module.exports = __webpack_public_path__ + "img/dariaPushkova@2x.322b03a3.jpg";